import { render } from "./DbSaveEditorCmp.vue?vue&type=template&id=a150b96a"
import script from "./DbSaveEditorCmp.vue?vue&type=script&lang=js"
export * from "./DbSaveEditorCmp.vue?vue&type=script&lang=js"

import "./DbSaveEditorCmp.vue?vue&type=style&index=0&id=a150b96a&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__